import React from 'react'

const MenuListItem = ({ node, isOpen, onMenuClick, children, currentMenu }) => {

    return (
        <li className='menu-item'>
            <a className={`${currentMenu.includes(node.name) && isOpen ? "activeElement" : ""}`} onMouseOver={onMenuClick}>{node?.name}</a>
            {isOpen && <ul className={`sub-menu`}>
                {children}
            </ul>}
        </li>
    );
};

export default MenuListItem